import { useApp } from '../../context/AppContext';

/**
 * Grid of template cards shown on the Templates tab. Each card has a
 * "︙" button that opens TemplateActionSheet (編集/削除) — that sheet
 * itself is mounted at the App-shell level (see App.jsx) and reads
 * its target template from AppContext, so this component only needs
 * to report which template was tapped.
 */
export default function TemplateList() {
  const { templates, openTemplateActionMenu } = useApp();

  return (
    <div className="template-grid">
      {templates.map((t) => (
        <div className="template-card" key={t.id} style={{ '--tpl-color': t.color }}>
          <button
            type="button"
            className="tpl-menu-btn"
            onClick={() => openTemplateActionMenu(t)}
            aria-label="メニュー"
          >
            ︙
          </button>
          <div className="tpl-icon">
            {t.icons && t.icons.length > 0 ? (
              t.icons.map((ic, i) => <span key={i}>{ic}</span>)
            ) : (
              <span>📌</span>
            )}
          </div>
          <div className="tpl-name">{t.name}</div>
          <div className="tpl-sub">
            📍 {t.place}
            <br />
            🔔 {t.notify}
          </div>
        </div>
      ))}
    </div>
  );
}
